import styled from "styled-components";

export const ToolbarContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 0 0 8px;
  gap: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ToolbarContent = styled.div`
  width: 100%;
  height: auto;
  gap: 8px;
  display: flex;
  align-items: center;
`;

export const ToggleButton = styled.button`
  all: unset;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  > img {
    width: 100%;
    height: auto;
    max-width: 26px;
  }

  :hover {
    opacity: 0.7;
  }
`;

export const SearchFilterGroup = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const FilterImage = styled.img`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: flex;
  cursor: pointer;

  :hover {
    opacity: 0.7;
  }

  @media (min-width: 768px) {
    display: none;
  }
`;

export const DesktopSidebar = styled.div`
  width: 100%;
  max-width: 248px;
  flex-shrink: 0;

  @media (max-width: 767px) {
    display: none;
  }
`;
